<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        供应商列表
        <div @click="geting()" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="line-height: 46px;padding-left: 10px;">筛选查询</div>
        <router-link to="/admin/addSupplier">
          <el-button plain class="addSupplier">添加供应商</el-button>
        </router-link>
      </div>
      <div style="background-color:#fff;">
        <el-row class="search" :gutter="10">
          <el-col :span="4">
            <div class="label">供应商名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" clearable size="small" placeholder="名称"></el-input>
          </el-col>
          <el-col :span="4">
            <div class="label">供应商类型:</div>
          </el-col>
          <el-col :span="4">
            <el-select size="small" v-model="type" placeholder="请选择">
              <el-option
                v-for="item in typeData"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <div class="label">电话:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="phone" clearable size="small" placeholder="电话"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">状态:</div>
          </el-col>
          <el-col :span="4">
            <el-select size="small" v-model="statue" placeholder="请选择">
              <el-option v-for="item in statueData" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>

      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column width="60" prop="id" label="编号" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center">
          <template slot-scope="scope">
            <router-link :to="'/admin/supplierDetail/'+scope.row.id">
              <el-link type="primary">{{scope.row.name}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="供应商类型" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" align="center"></el-table-column>
        <el-table-column prop="province" label="城市" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="buyer" label="采购员" align="center"></el-table-column>
        <el-table-column prop="create_member" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" name="bianji">
          <template slot-scope="scope">
            <el-link v-if="scope.row.statue == 0" type="primary" @click="agree(scope.row.id)">审核通过</el-link>
            <el-link style="margin-left:20px" type="primary" @click="supplierDel(scope.row.id)">删除</el-link>
            <router-link :to="'/admin/supplierEdit/' + scope.row.id">
              <el-link v-if="scope.row.statue == 1" style="margin-left:20px" type="primary">编辑</el-link>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          background
          style="width:400px;margin:0 auto;text-align:center"
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      id: "",
      page: null,
      total: 0,
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      typeData: [
        {
          id: 0,
          sort: "0",
          name: "全部"
        },
        {
          id: 1,
          sort: "1",
          name: "业立区域签约代理"
        },
        {
          id: 2,
          sort: "2",
          name: "全国总代理"
        },
        {
          id: 3,
          sort: "3",
          name: "区域独家代理"
        },
        {
          id: 4,
          sort: "4",
          name: "区域一级代理"
        },
        {
          id: 5,
          sort: "5",
          name: "国外直供"
        },
        {
          id: 6,
          sort: "6",
          name: "厂家直供零采"
        }
      ],
      type: "",
      statueData: ["全部", "未审核", "已审核"],
      statue: "",
      phone: "",
      name: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 12;
    this.$store.state.leftTitle = "供应商表";
    this.geting();
  },
  watch: {},
  methods: {
    agree(id) {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.axios
        .get(this.serve + "/admin/supplierAgree", {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          let data = res.data;
          let tableData = this.tableData;
          if (data.status == "success") {
            for (let i in tableData) {
              if (tableData[i].id == id) {
                tableData[i].statue = 1;
              }
            }
            that.$message({
              showClose: true,
              message: "供应商审核通过",
              type: "success",
              offset: 300
            });
          } else {
            that.$message({
              showClose: true,
              message: data.msg + "|供应商审核失败",
              type: "error",
              offset: 300
            });
          }
          loading.close();
        });
    },
    supplierDel(id) {
      this.$confirm("此操作将永久删除该供应商, 是否继续?", "删除供应商", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/supplierDel", {
              params: {
                username: this.username,
                token: this.token,
                id: id
              }
            })
            .then(res => {
              let data = res.data;
              if (data.status == "success") {
                this.geting();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                  offset: 200
                });
              } else {
                this.$message({
                  type: "error",
                  message: data.msg,
                  offset: 200
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 200
          });
        });
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    geting(page) {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (!page) {
        page = 1;
      }
      let where = {
        page: page,
        username: this.username,
        token: this.token
      };
      if (this.type != "" || this.type != "全部") {
        where.type = this.type;
      }
      if (this.name != "") {
        where.name = this.name;
      }
      if (this.phone != "") {
        where.phone = this.phone;
      }
      if (this.statue != "" || this.statue != "全部") {
        where.statue = this.statue;
      }

      this.axios(this.serve + "/admin/supplierList", { params: where }).then(
        res => {
          let data = res.data;
          if (data.status == "success") {
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            if(data.msg == '无权访问')
            {
              this.role = false
            }
            this.tableData = [];
          }
          loading.close();
        }
      );
    }
  }
};
</script>
<style lang="scss">
.list {
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .pager {
    background-color: #fff;
    height: 50px;
  }
  .addSupplier {
    margin-right: 20px;
  }
  .addSupplier:hover {
    color: white;
    background-color: #0099ff;
  }

  .form-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  background: #f5f5f5;

  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }

  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .search {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>